module.exports = __webpack_public_path__ + "static/media/DC_F_Embroidery_Accademia_White_3955_3377_3364.d3db4501.png";